import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpHelper } from '../shared/http-helper';

@Injectable()
export class CommonDataService {
    private _serviceUrlPrefix: string = '/api/data';

    constructor(private _httpHelper: HttpHelper) { }

    public getData(source: string): Observable<KeyValuePair[]> {
        return this._httpHelper.get(`${this._serviceUrlPrefix}/${source}`);
    }

    public getSystemControlData(): Observable<SystemControl> {
        return this._httpHelper.get(`${this._serviceUrlPrefix}/systemcontrol`);
    }

    public getVariableInfo():Observable<VariableInfo[]>{
        return this._httpHelper.get(`${this._serviceUrlPrefix}/variableinfo`);
    }

    public getEnplanementYears():Observable<number[]>{
        return this._httpHelper.get(`${this._serviceUrlPrefix}/enplanementyears`);
    }
}

export class KeyValuePair {
    key: string;
    value: string;
}

export class SystemControl {
    fyYear: number;
    ffcYear: number;
    lfcYear: number;
    mangrLock: number;
    copyType: number;
    copyScena: number;
    ldEmdf: Date;
    lyEmdf: number;
    ldAops: Date;
    lyAops: number;
    ldAppr: Date;
    lyAppr: number;
    ldEnpl: Date;
    lyEnpl: number;
    ldNfdc: Date;
    lyNfdc: number;
    ldAsvd: Date;
    lyAsvd: number;
    lScenId: number;
    esma: number;
    esmc: number;
    importStage: number;
    dateStepCompleted: Date;
}

export class VariableInfo {
    displayVariable: string;
    searchVariable: string;
}


/** WEBPACK FOOTER **
 ** ./app/common-data/commondata.service.ts
 **/